import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@metarouter-private/mr-mui';
import PipelineTransformationsDrawerHeader from 'app/pipeline-details/PipelineTransformationsSection/PipelineTransformationsDrawer/shared/PipelineTransformationsDrawerHeader';
import PipelineTransformationsYamlEditor from '../shared/PIpelineTransformationsYamlEditor';
import { Typography } from '@metarouter-private/mr-mui';

export default function PipelineTransformationsDrawerContent({ transform }) {
  return (
    <>
      <PipelineTransformationsDrawerHeader
        title="Pipeline Transforms"
        documentationUrl="https://docs.metarouter.io/docs/transformation-library#workflow"
      />
      <Stack spacing={1}>
        <PipelineTransformationsYamlEditor name="pipeline-transforms" value={transform} />
        <Typography variant="body2" color="secondary">
          {"It is best practice to use Lua Modules if you're going to do transforms across multiple pipelines."}
        </Typography>
      </Stack>
    </>
  );
}

PipelineTransformationsDrawerContent.propTypes = {
  transform: PropTypes.object.isRequired,
};
